import { gql } from '@apollo/client/core'

import { ATTRIBUTE_FRAGMENT } from '@base/api/fragments/attribute'

export const ONLY_PLAYER_EVENT_FRAGMENT = gql`
  ${ATTRIBUTE_FRAGMENT}
  fragment OnlyPlayerEvent on Event {
    id
    name
    slug
    visibility
    createdAt
    description
    dateStart
    dateEnd
    exclusive
    registrationStart
    registrationEnd
    status
    eventTypes {
      ...Attribute
    }
    eventAttributes {
      ...Attribute
    }
    gallery
    galleryPaths
    isNonGolf
  }
`
